import { SelectOption } from '@/const/types'

export const genderOptions: SelectOption[] = [
	{ label: 'Female', value: 'Female' },
	{ label: 'Male', value: 'Male' }
]

export const expandedGenderOption: SelectOption[] = [
	{ label: 'All', value: 'All' },
	{ label: 'Female', value: 'Female' },
	{ label: 'Male', value: 'Male' }
]

export const preferredPronounsOptions: SelectOption[] = [
	{ label: 'She/Her/Hers', value: 'she/her/hers' },
	{ label: 'He/Him/His', value: 'he/him/his' },
	{ label: 'They/Them/Theirs', value: 'they/them/theirs' }
]
